const AUTH_PATH_PREFIXES = ["/sign-in", "/sign-up"];

/**
 * Returns true for Clerk authentication paths (sign-in, sign-up, and their
 * sub-paths such as SSO callbacks and verification hops).
 */
export function isAuthPath(pathname: string): boolean {
  return AUTH_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

/**
 * Routes that stay reachable on phone-sized screens. Everything else falls
 * back to the desktop-only takeover, but users still need to be able to
 * create an account (and finish Clerk's SSO/verification hops) from a phone.
 */
export const isMobileAllowedPath = isAuthPath;
